import { Nullable } from 'types/utility'

const NON_WORLD_REGION_NAMES = ['china', 'europe', 'apac']
const WORLD_REGION_NAME = 'world'
const REGION_NAME_PATTERN = new RegExp(
  String.raw`\b(${[...NON_WORLD_REGION_NAMES, WORLD_REGION_NAME].join('|')})\b`,
  'gi',
)

const getRegionName = (regionValue: string): string => {
  const normalizedRegionValue = regionValue.trim().toLowerCase()

  if (normalizedRegionValue === 'cn') {
    return 'china'
  }

  return (
    NON_WORLD_REGION_NAMES.find((regionName) => normalizedRegionValue.includes(regionName)) ??
    WORLD_REGION_NAME
  )
}

const getEnvironmentName = (regionKey: string): string =>
  regionKey.replace(REGION_NAME_PATTERN, '').trim().toLowerCase()

/**
 * Maps a user's stored home region to a configured region key from the runtime env,
 * preferring the key of the same environment as the currently selected region
 * (e.g. "release china" -> "release"), or null when the user's region is unknown.
 */
export const resolveTargetRegionKey = (userRegion: Nullable<string>): Nullable<string> => {
  if (userRegion == null || userRegion.trim() === '') {
    return null
  }

  const regions = Object.keys(window.env('REGIONS'))
  const normalizedUserRegion = userRegion.trim().toLowerCase()
  const exactMatch = regions.find((region) => region.toLowerCase() === normalizedUserRegion)

  if (exactMatch != null) {
    return exactMatch
  }

  const targetRegionName = getRegionName(normalizedUserRegion)
  const candidateRegions = regions.filter((region) => getRegionName(region) === targetRegionName)
  const currentEnvironmentName = getEnvironmentName(window.env('REGION') ?? '')

  return (
    candidateRegions.find((region) => getEnvironmentName(region) === currentEnvironmentName) ??
    candidateRegions[0] ??
    null
  )
}
